var _rect, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPm25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 99,
    viewBox: "0 0 108 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_197_4107",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    width: 80,
    height: 80,
    fill: "url(#paint0_linear_197_4107)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_197_4107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6668 66.6663C30.5557 66.6663 26.2224 64.8886 22.6668 61.333C19.1113 57.7775 17.3335 53.4441 17.3335 48.333C17.3335 43.9997 18.6807 40.1802 21.3752 36.8747C24.0696 33.5691 27.4446 31.4441 31.5002 30.4997C32.8891 25.4997 35.6391 21.3886 39.7502 18.1663C43.8613 14.9441 48.6113 13.333 54.0002 13.333C60.6113 13.333 66.1529 15.6247 70.6252 20.208C75.0974 24.7913 77.3335 30.2775 77.3335 36.6663C81.5002 37.1108 84.7641 38.833 87.1252 41.833C89.4863 44.833 90.6668 48.083 90.6668 51.583C90.6668 55.7497 89.2085 59.3052 86.2918 62.2497C83.3752 65.1941 79.8335 66.6663 75.6668 66.6663H35.6668ZM35.6668 59.9997H75.6668C78.0002 59.9997 79.9724 59.1941 81.5835 57.583C83.1946 55.9719 84.0002 53.9997 84.0002 51.6663C84.0002 49.333 83.1946 47.3608 81.5835 45.7497C79.9724 44.1386 78.0002 43.333 75.6668 43.333H70.6668V36.6663C70.6668 32.0552 69.0418 28.1247 65.7918 24.8747C62.5418 21.6247 58.6113 19.9997 54.0002 19.9997C50.5002 19.9997 47.3891 20.958 44.6668 22.8747C41.9446 24.7913 39.9446 27.2497 38.6668 30.2497C43.0002 30.9719 46.6391 33.0136 49.5835 36.3747C52.5279 39.7358 54.0002 43.7219 54.0002 48.333H47.3335C47.3335 45.1108 46.1946 42.3608 43.9168 40.083C41.6391 37.8052 38.8891 36.6663 35.6668 36.6663C32.4446 36.6663 29.6946 37.8052 27.4168 40.083C25.1391 42.3608 24.0002 45.1108 24.0002 48.333C24.0002 51.5552 25.1391 54.3052 27.4168 56.583C29.6946 58.8608 32.4446 59.9997 35.6668 59.9997Z",
    fill: "url(#paint1_linear_197_4107)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.728 53.1584H13.5552C16.6784 53.1584 19.1744 53.9776 21.0432 55.616C22.912 57.2544 23.8464 59.5456 23.8464 62.4896C23.8464 65.5104 22.912 67.8528 21.0432 69.5168C19.2 71.1552 16.704 71.9744 13.5552 71.9744H8.5248V80H1.728V53.1584ZM12.48 66.2528C13.8368 66.2528 14.8992 65.9712 15.6672 65.408C16.4608 64.8448 16.8576 63.872 16.8576 62.4896C16.8576 61.1072 16.4736 60.16 15.7056 59.648C14.9376 59.136 13.8624 58.88 12.48 58.88H8.5248V66.2528H12.48ZM26.1405 53.1584H32.6685L40.4253 69.7856L48.2205 53.1584H54.7101V80H48.3741V66.5216L41.9613 80H38.8893L32.5149 66.5216V80H26.1405V53.1584ZM57.3975 76.1216L61.6599 72.2432L63.5031 70.592C65.0135 69.2608 66.1655 68.1984 66.9591 67.4048C67.7783 66.6112 68.4439 65.8048 68.9559 64.9856C69.4935 64.1664 69.7623 63.36 69.7623 62.5664C69.7623 60.1856 68.4183 58.9952 65.7303 58.9952C64.4247 58.9952 63.1319 59.2256 61.8519 59.6864C60.5975 60.1472 59.4327 60.7872 58.3575 61.6064V55.1168C59.5095 54.3232 60.8535 53.7088 62.3895 53.2736C63.9255 52.8128 65.5639 52.5824 67.3047 52.5824C69.3015 52.5824 71.0295 52.9536 72.4887 53.696C73.9479 54.4384 75.0615 55.4624 75.8295 56.768C76.5975 58.0736 76.9815 59.5456 76.9815 61.184C76.9815 63.1552 76.5207 64.8832 75.5991 66.368C74.7031 67.8272 73.2439 69.4784 71.2215 71.3216L67.8039 74.432H77.8263V80H57.3975V76.1216ZM82.1667 80C81.5011 80 80.9251 79.7696 80.4387 79.3088C79.9779 78.848 79.7475 78.2848 79.7475 77.6192C79.7475 76.928 79.9779 76.3392 80.4387 75.8528C80.9251 75.3664 81.5011 75.1232 82.1667 75.1232C82.8579 75.1232 83.4339 75.3664 83.8947 75.8528C84.3811 76.3392 84.6243 76.928 84.6243 77.6192C84.6243 78.2848 84.3811 78.848 83.8947 79.3088C83.4339 79.7696 82.8579 80 82.1667 80ZM94.8294 80.576C93.2934 80.576 91.7702 80.4096 90.2598 80.0768C88.7494 79.744 87.5078 79.2832 86.535 78.6944V72.7424C87.687 73.4848 88.9798 74.0736 90.4134 74.5088C91.8726 74.9184 93.2422 75.1232 94.5222 75.1232C96.3142 75.1232 97.6454 74.7776 98.5158 74.0864C99.3862 73.3952 99.8214 72.448 99.8214 71.2448C99.8214 70.0928 99.3734 69.1968 98.4774 68.5568C97.607 67.9168 96.3782 67.5968 94.791 67.5968C93.895 67.5968 92.9478 67.6864 91.9494 67.8656C90.9766 68.0192 90.1318 68.2496 89.415 68.5568L86.8038 67.0592L87.879 53.1584H105.082V58.7264H94.4454L94.0998 62.9504C95.2774 62.6432 96.5318 62.4896 97.863 62.4896C100.653 62.4896 102.829 63.232 104.391 64.7168C105.978 66.176 106.772 68.288 106.772 71.0528C106.772 74.048 105.761 76.3904 103.738 78.08C101.716 79.744 98.7462 80.576 94.8294 80.576Z",
    fill: "url(#paint2_linear_197_4107)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_197_4107",
    x1: 54,
    y1: 0,
    x2: 54,
    y2: 92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#643B74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9175A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_197_4107",
    x1: 54.0002,
    y1: 13.333,
    x2: 54.0002,
    y2: 74.6663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#643B74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9175A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_197_4107",
    x1: 0.0000021616,
    y1: 41,
    x2: 116,
    y2: 91.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#86469C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC98C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPm25);
export default __webpack_public_path__ + "static/media/PM25.fcecaed531bb8e6cffe6789f58d85fad.svg";
export { ForwardRef as ReactComponent };